<div class="reports-cntr">

  <app-reports-issue-card [configuration]="SellerConfiguration"></app-reports-issue-card>
  <app-reports-issue-card [configuration]="BuyerConfiguration"></app-reports-issue-card> 


</div>